<div class="accordion" id="accordionKwijtscheldingen" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingKwijtscheldingen1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseKwijtscheldingen1" aria-expanded="false"
                    aria-controls="collapseKwijtscheldingen1">
                Kwijtscheldingen
            </button>
        </h2>
        <div id="collapseKwijtscheldingen1" class="accordion-collapse collapse"
             aria-labelledby="headingKwijtscheldingen1" data-bs-parent="#accordionKwijtscheldingen">
            <div class="accordion-body">
                Dit betreft geen feitelijke schenking, maar een schuld die niet meer ingelost dient te worden.
                <div class="space20"></div>
                Een kwijtschelding van een schuld, mits zonder tegenprestatie, kwalificeert als schenking. De schenking
                is gelijk aan het kwijtgescholden bedrag.
                Dit komt regelmatig voor binnen familiesituaties, bijvoorbeeld bij leningen voor woningfinanciering.
                Indien geen rente of aflossing wordt gevraagd,
                kan de fiscus dit zien als een verkapte schenking.
                <div class="space20"></div>
                Het verdient aanbeveling om bij de kwijtschelding een schriftelijke overeenkomst op te stellen en aan te
                geven of sprake is van een gedeeltelijke of volledige kwijtschelding,
                om de fiscale behandeling correct vast te stellen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingKwijtscheldingen2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseKwijtscheldingen2" aria-expanded="false"
                    aria-controls="collapseKwijtscheldingen2">
                Geen schenking als schuldenaar schulden niet kan betalen
            </button>
        </h2>
        <div id="collapseKwijtscheldingen2" class="accordion-collapse collapse"
             aria-labelledby="headingKwijtscheldingen2" data-bs-parent="#accordionKwijtscheldingen">
            <div class="accordion-body">
                Een uitzondering dat een kwijtschelding een schenking is, geldt wanneer de schuldenaar aantoonbaar niet
                in staat was om zijn schulden te betalen.
                In dat geval wordt de kwijtschelding niet als schenking belast.
                <div class="space20"></div>
                Bij de beoordeling kijkt men naar de financiële situatie van de schuldenaar op het moment van de
                kwijtschelding.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingKwijtscheldingen3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseKwijtscheldingen3" aria-expanded="false"
                    aria-controls="collapseKwijtscheldingen3">
                Waarde kwijtschelding schuld
            </button>
        </h2>
        <div id="collapseKwijtscheldingen3" class="accordion-collapse collapse"
             aria-labelledby="headingKwijtscheldingen3" data-bs-parent="#accordionKwijtscheldingen">
            <div class="accordion-body">
                De 'waarde kwijtschelding schuld' is de waarde in het economisch verkeer van de schuld op de dag van de
                kwijtschelding, oftewel de dag waarop de schenking plaatsvindt.
                <div class="space20"></div>
                De Belastingdienst kan een kwijtschelding van schuld aanmerken als een schenking, waarover
                schenkbelasting verschuldigd kan zijn.
                <div class="space20"></div>
                Een uitzondering geldt wanneer de schuldenaar aantoonbaar niet in staat was om zijn schulden te betalen.
                In dat geval wordt de kwijtschelding niet als schenking belast.
                <div class="space20"></div>
                Bij de beoordeling kijkt men naar de financiële situatie van de schuldenaar op het moment van de
                kwijtschelding.
            </div>
        </div>
    </div>
</div>
